<template>
  <div class="service-page">
    <div class="container">
      <h1>用户服务协议</h1>
      <div class="update-date">生效日期：2025年12月22日</div>
      
      <div class="info">
        <p><strong>公司名称：</strong>河北雄安思知科技有限公司</p>
        <p><strong>平台名称：</strong>小虫单</p>
        <p><strong>联系方式：</strong>如有任何疑问，请通过App内客服功能联系我们</p>
      </div>

      <p>欢迎使用"小虫单"App！本用户服务协议（以下简称"本协议"）是您与河北雄安思知科技有限公司（以下简称"我们"或"公司"）之间关于使用"小虫单"App服务（以下简称"本服务"）的法律协议。请您仔细阅读本协议的全部内容，特别是涉及免除或限制责任的条款。如您不同意本协议的任何内容，请立即停止使用本应用。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。</p>

      <h2>一、协议范围</h2>
      <p>1.1 本协议是您与我们之间关于您使用"小虫单"App服务所订立的协议。</p>
      <p>1.2 "小虫单"App是指我们开发和运营的移动应用程序，主要提供工单管理、店铺管理、部门管理、员工管理、检查服务、消息通知、数据统计等企业服务功能。</p>
      <p>1.3 本协议描述您与我们之间关于"本服务"使用的权利义务。"服务"是指我们向您提供的"小虫单"App及相关服务。</p>

      <h2>二、账户注册与使用</h2>
      <p>2.1 您在使用本服务前需要注册一个账户。注册账户时，您应当提供真实、准确、完整的信息，并保证信息的及时更新。</p>
      <p>2.2 您应当妥善保管您的账户信息及密码，因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。您需要对您账户下的所有行为负责。</p>
      <p>2.3 您不得将账户转让、出售、出租或以其他方式提供给第三方使用，否则我们有权立即终止向您提供服务，并保留追究您法律责任的权利。</p>
      <p>2.4 如您发现账户被盗用或存在安全漏洞，请立即通知我们。我们将协助您采取相应措施，但因此造成的损失由您自行承担。</p>
      <p>2.5 我们有权对您提交的注册信息进行审核，如发现您提供的信息不真实、不准确或不完整，我们有权拒绝或终止向您提供服务。</p>

      <h2>三、服务内容</h2>
      <p>3.1 "小虫单"App主要提供以下服务功能：</p>
      <ul>
        <li><strong>工单管理：</strong>包括工单创建、查看、修改、搜索、签到、审批等功能；</li>
        <li><strong>店铺管理：</strong>包括店铺信息管理、店铺定位、店铺详情查看等功能；</li>
        <li><strong>部门管理：</strong>包括部门信息管理、部门层级查看等功能；</li>
        <li><strong>员工管理：</strong>包括员工信息管理、员工详情查看等功能；</li>
        <li><strong>检查服务：</strong>包括各类检查任务的管理、检查记录的上传和查看等功能；</li>
        <li><strong>消息通知：</strong>包括系统消息、业务通知的接收和查看等功能；</li>
        <li><strong>数据统计：</strong>包括业务数据的统计和分析等功能；</li>
        <li><strong>其他相关服务功能。</strong></li>
      </ul>
      <p>3.2 我们有权根据业务发展需要调整、变更或终止部分或全部服务功能，但我们会提前通知您。</p>
      <p>3.3 我们保留随时修改或中断服务而不需通知用户的权利。我们行使修改或中断服务的权利，不需对用户或第三方负责。</p>

      <h2>四、用户行为规范</h2>
      <p>4.1 您在使用本服务时，应当遵守相关法律法规，不得利用本服务从事违法违规活动，包括但不限于：</p>
      <ul>
        <li>发布、传播、存储违反国家法律法规的内容；</li>
        <li>发布、传播、存储侵害他人知识产权、商业秘密等合法权益的内容；</li>
        <li>发布、传播、存储涉及他人隐私、个人信息、商业秘密的内容；</li>
        <li>发布、传播骚扰、广告信息、垃圾信息或任何其他形式的骚扰信息；</li>
        <li>发布、传播含有病毒、木马、恶意代码等可能危害计算机系统安全的内容；</li>
        <li>从事任何危害计算机网络安全的行为；</li>
        <li>其他违反法律法规、社会公德的行为。</li>
      </ul>
      <p>4.2 您应当保证您上传、发布的内容真实、准确、合法，不侵犯任何第三方的合法权益。</p>
      <p>4.3 您不得利用本服务进行任何可能对互联网的正常运转造成不利影响的行为。</p>
      <p>4.4 您不得利用本服务进行任何不利于我们的行为。</p>
      <p>4.5 如您违反本协议约定，我们有权立即终止向您提供服务，并保留追究您法律责任的权利。</p>

      <h2>五、知识产权</h2>
      <p>5.1 本服务中包含的所有内容，包括但不限于文字、图片、音频、视频、软件、程序、版面设计、专栏目录与名称、内容分类标准等，均受《中华人民共和国著作权法》、《中华人民共和国商标法》等法律法规的保护。</p>
      <p>5.2 本服务所包含的软件、技术、程序、代码、用户界面等知识产权均归我们所有。</p>
      <p>5.3 未经我们书面许可，您不得以任何形式使用、复制、修改、传播、展示、镜像、上传、下载本服务中的内容。</p>
      <p>5.4 您在使用本服务过程中上传、发布的内容，您保留其知识产权，但您授予我们在全球范围内免费、非独占、可再许可的使用权，用于提供、推广和改进本服务。</p>

      <h2>六、隐私保护</h2>
      <p>6.1 我们非常重视您的隐私保护。关于我们如何收集、使用、存储和保护您的个人信息，请详见《隐私政策》。</p>
      <p>6.2 您在使用本服务时，我们可能会收集您的设备信息、位置信息、操作日志等信息，用于提供、维护和改进本服务。</p>
      <p>6.3 我们承诺不会向第三方出售、出租或以其他方式披露您的个人信息，但法律法规另有规定的除外。</p>

      <h2>七、免责声明</h2>
      <p>7.1 您理解并同意，在使用本服务过程中可能遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失，我们在法律允许的范围内免责。</p>
      <p>7.2 您理解并同意，在使用本服务过程中存在来自任何他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）的匿名或冒名的信息的风险，您须承担以上风险，我们对本服务不作任何类型的保证，不论是明示的或默示的，包括但不限于本服务的及时性、安全性、准确性，对特定用途的适用性，以及非侵权性等。</p>
      <p>7.3 我们不对因下述任一情况而导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿：</p>
      <ul>
        <li>使用或未能使用本服务；</li>
        <li>第三方未经批准的使用您的账户或更改您的数据；</li>
        <li>通过本服务购买或获取任何商品、样品、数据、信息等行为或替代行为产生的费用及损失；</li>
        <li>您对本服务的误解；</li>
        <li>任何非因我们的原因而引起的与本服务有关的其他损失。</li>
      </ul>
      <p>7.4 我们不对本服务中涉及的第三方服务提供商的服务的可用性、准确性、可靠性、完整性负责。</p>

      <h2>八、服务变更、中断或终止</h2>
      <p>8.1 我们有权根据业务发展需要调整、变更或终止部分或全部服务功能。</p>
      <p>8.2 如发生下列任何一种情形，我们有权随时中断或终止向您提供本服务而无需对您或任何第三方承担任何责任：</p>
      <ul>
        <li>您提供的个人资料不真实；</li>
        <li>您违反本协议中的规定；</li>
        <li>您违反相关法律法规；</li>
        <li>按照法律规定或主管部门的要求；</li>
        <li>其他我们认为需要中断或终止服务的情形。</li>
      </ul>
      <p>8.3 服务中断或终止后，我们有权删除您的账户信息、服务内容等相关数据，法律法规另有规定的除外。</p>

      <h2>九、协议修改</h2>
      <p>9.1 我们有权根据业务发展需要修改本协议。修改后的协议将在本页面公布，并在显著位置提示您查看。</p>
      <p>9.2 重大变更时，我们还会通过App内通知等方式告知您。更新后的协议自公布之日起生效。</p>
      <p>9.3 如您不同意更新后的协议，请立即停止使用本服务。如您继续使用本服务，即视为您已接受更新后的协议。</p>

      <h2>十、法律适用与争议解决</h2>
      <p>10.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国大陆地区法律。</p>
      <p>10.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向我们住所地有管辖权的人民法院提起诉讼。</p>

      <h2>十一、其他条款</h2>
      <p>11.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
      <p>11.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
      <p>11.3 本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>

      <h2>十二、联系我们</h2>
      <p>如果您对本协议有任何疑问、意见或建议，请通过以下方式联系我们：</p>
      <ul>
        <li>通过App内客服功能联系我们；</li>
        <li>发送邮件至我们的客服邮箱（support@xcdan.com）。</li>
      </ul>
      <p>我们将在收到您的反馈后尽快回复。</p>

      <div class="footer">
        <p>河北雄安思知科技有限公司</p>
        <p>小虫单平台</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'ServicePage',
  mounted() {
    // 页面加载动画
    this.$nextTick(() => {
      document.querySelector('.container')?.classList.add('fade-in')
    })
  }
}
</script>

<style lang="scss" scoped>
.service-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  animation: fadeIn 0.6s ease;

  .container {
    max-width: 900px;
    margin: 0 auto;
    background-color: #fff;
    padding: 40px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.6s ease;

    &.fade-in {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h1 {
    font-size: 28px;
    color: #1B5898;
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #1B5898;
    animation: slideDown 0.6s ease;
  }

  h2 {
    font-size: 20px;
    color: #1B5898;
    margin-top: 30px;
    margin-bottom: 15px;
    padding-left: 10px;
    border-left: 4px solid #1B5898;
    animation: slideInLeft 0.5s ease;
  }

  p {
    margin-bottom: 15px;
    text-align: justify;
    text-indent: 2em;
    line-height: 1.8;
    color: #333;
    animation: fadeInUp 0.5s ease;
  }

  .info {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f9f9f9;
    border-left: 4px solid #1B5898;
    border-radius: 4px;
    animation: fadeInUp 0.5s ease 0.2s both;

    p {
      text-indent: 0;
      margin-bottom: 5px;
    }
  }

  ul {
    margin-left: 2em;
    margin-bottom: 15px;
    animation: fadeInUp 0.5s ease;

    li {
      margin-bottom: 8px;
      line-height: 1.8;
      color: #333;

      .highlight {
        color: #1B5898;
        font-weight: bold;
      }
    }
  }

  .footer {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #e0e0e0;
    text-align: right;
    color: #666;
    font-size: 14px;
    animation: fadeInUp 0.5s ease;
  }

  .update-date {
    text-align: center;
    color: #999;
    font-size: 14px;
    margin-bottom: 30px;
    animation: fadeIn 0.5s ease;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .service-page {
    padding: 10px;

    .container {
      padding: 20px;
    }

    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 18px;
    }

    p {
      font-size: 14px;
    }
  }
}
</style>

